import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import Styles from './index.module.scss';
import { DocsStore } from '@/pages/docs/models';
import DocMenu from '@/pages/docs/component/DocMenu';
import DocContent from '@/pages/docs/component/DocContent';
import { useUrlQuery, useUrlSerach } from '@/utils/hooks/common';
import { useHistory } from 'react-router-dom';

function Docs() {
  const docsInfoStore = useContext(DocsStore);
  const { activeDocId, activeHash } = docsInfoStore;
  const history = useHistory();
  const {
    identify_key: identifyKey,
    doc_id: docId,
    language,
    size,
  } = useUrlQuery();

  useEffect(() => {
    const { hash } = history.location;
    docsInfoStore.language = language;
    docsInfoStore.identifyKey = identifyKey;
    docsInfoStore.activeDocId = parseInt(docId, 10);
    docsInfoStore.activeHash = hash;
    // 没有平台identifyKey就返回
    if (!docsInfoStore.identifyKey) { return window.history.back(); }
    docsInfoStore.getPlatConfig();
  }, []);

  useEffect(() => {
    if (activeDocId) {
      const { search } = history.location;
      // eslint-disable-next-line @typescript-eslint/camelcase
      const newSearch = useUrlSerach(search, { doc_id: activeDocId, language: docsInfoStore.language });
      history.push({ search: newSearch, hash: activeHash });
      // 向父级 iframe 传递信息
      window.parent.postMessage({ id: activeDocId }, '*');
    }
  }, [activeDocId, activeHash, docsInfoStore.language]);

  return (
    <div className={`${Styles.container} ${size}`}>
      <DocMenu />
      <DocContent />
    </div>
  );
}

export default React.memo(observer(Docs));
